import i18next from 'i18next';

import {gistApi, requestHelper, responseHelper} from "../../_helpers";
import {notificationConstants} from "../../_constants";

export const zoomIntegrationService = {
    connect,
    disconnect,
    getRecordings,
};

/**
 * This function send request to persist a zoom integration based on given code
 *
 * @param code the authorization code received from Zoom
 * @returns {Promise<never>} connection successful or not
 */
function connect(code) {
    let myHeader = requestHelper.authHeader();
    let link = '/api/users/integrations/zoom/connect';
    const t = i18next.t;

    return gistApi.post(link, {code: code},{headers: myHeader})
        .then(response => {
            return responseHelper.handleResponse(response);
        })
        .then(response => {
            return response;
        })
        .catch(error => {
            let res = {
                "status": 500,
                "errorMsg": t("Sorry, we're having technical issues. Please try again.")
            };
            if (error && error.response) {
                res.status = error.response.status;
                if (error.response.status === 400) {
                    res.errorMsg = t('The Zoom account could not be integrated. Please try again.');
                    res.toastParams = {"toastType": notificationConstants.NOTIFICATION_TYPES.ERROR}
                }
            }
            return Promise.reject(res);
        })
}

/**
 * This function send request to persist a remove a zoom integration
 *
 * @returns {Promise<never>} connection successful or not
 */
function disconnect() {
    let myHeader = requestHelper.authHeader();
    let link = '/api/users/integrations/zoom';
    const t = i18next.t;

    return gistApi.delete(link, {headers: myHeader})
        .then(response => {
            return responseHelper.handleResponse(response);
        })
        .then(response => {
            return response;
        })
        .catch(error => {
            let res = {
                "status": 500,
                "errorMsg": t("Sorry, we're having technical issues. Please try again.")
            };
            if (error && error.response) {
                res.status = error.response.status;
                if (error.response.status === 404) {
                    res.errorMsg = t('The Zoom account could not be found anymore.');
                }
            }
            return Promise.reject(res);
        })
}

/**
 * This method fetches the zoom recordings
 *
 * @param query parameters for zoom fetch recording endpoint
 * @returns {Promise<never>} recording response or not
 */
function getRecordings(query) {
    let myHeader = requestHelper.authHeader();

    // prepare url with queries
    const queryString = require('query-string');
    const baseLink = '/api/users/integrations/zoom/recordings';
    const link = (Object.keys(query).length === 0)
                    ? baseLink
                    : baseLink + "?" + queryString.stringify(query);
    const t = i18next.t;

    return gistApi.get(link, {headers: myHeader})
        .then(response => {
            return responseHelper.handleResponse(response);
        })
        .then(response => {
            return response;
        })
        .catch(error => {
            let res = {
                "status": 500,
                "errorMsg": t("Sorry, we're having technical issues. Please try again.")
            };
            if (error && error.response) {
                res.status = error.response.status;
                switch(error.response.status) {
                    case 400:
                        res.errorMsg = t('There were issues with filter parameters. Please correct it.');
                        break;

                    case 401:
                        res.errorMsg = t('The Zoom account could not be found anymore.');
                        break;

                    default:
                        break;
                }
            }
            return Promise.reject(res);
        })
}